(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook-galeria"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.lookbook-grid').forEach((grid) => {
      let isDown = false;
      let startX = 0;
      let scrollStart = 0;

      const itemLeft = (item) =>
        item.getBoundingClientRect().left - grid.getBoundingClientRect().left + grid.scrollLeft;

      const snapSmooth = () => {
        const all = [...grid.querySelectorAll('.lookbook-item')];
        if (!all.length) { grid.style.scrollSnapType = ''; return; }

        let nearest = all[0];
        let nearestDist = Infinity;
        all.forEach((item) => {
          const dist = Math.abs(itemLeft(item) - grid.scrollLeft);
          if (dist < nearestDist) { nearestDist = dist; nearest = item; }
        });

        grid.scrollTo({ left: itemLeft(nearest), behavior: 'smooth' });

        const done = () => {
          grid.style.scrollSnapType = '';
          grid.removeEventListener('scrollend', done);
        };
        grid.addEventListener('scrollend', done);
      };

      grid.addEventListener('dragstart', (e) => e.preventDefault());

      grid.addEventListener('mousedown', (e) => {
        if (e.button !== 0) return;
        e.preventDefault();
        isDown = true;
        startX = e.pageX;
        scrollStart = grid.scrollLeft;
        grid.style.cursor = 'grabbing';
        grid.style.userSelect = 'none';
        grid.style.scrollSnapType = 'none';
      });

      document.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        grid.scrollLeft = scrollStart + (startX - e.pageX);
      });

      const release = (e) => {
        if (!isDown) return;
        const moved = Math.abs(e.pageX - startX) > 4;
        isDown = false;
        grid.style.cursor = '';
        grid.style.userSelect = '';
        if (moved) {
          grid.addEventListener('click', (ev) => ev.preventDefault(), { once: true, capture: true });
          snapSmooth();
        } else {
          grid.style.scrollSnapType = '';
        }
      };

      document.addEventListener('mouseup', release);
      document.addEventListener('mouseleave', release);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  function syncTimelineLabels(component) {
    const slides = component.querySelectorAll('slideshow-slide[data-timeline-label]');
    const labels = component.querySelectorAll('.slideshow-timeline__label');
    slides.forEach((slide, i) => {
      if (labels[i]) labels[i].textContent = slide.dataset.timelineLabel || '';
    });
  }

  document.querySelectorAll('slideshow-component').forEach((component) => {
    syncTimelineLabels(component);
    new MutationObserver(() => syncTimelineLabels(component)).observe(component, {
      subtree: true,
      attributes: true,
      attributeFilter: ['data-timeline-label'],
    });
  });

  } catch(e) { console.error(e); }
})();
})();
